import { toast } from 'react-toastify';

export const hqlistdata = async(hqObj)=>{

    try {
        let hqhirdata = hqObj;            
        const hqres = await fetch('/tcsdb/hirhqmapdata/'+hqhirdata, {
            method: "GET",
                headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
                },
                credentials: "include"  
        });
        
        const hqresdata = await hqres.json();
        // console.log(hqresdata);
        if(hqresdata.status === 404)
        {
            toast.error("You don't have access of HQ.", { position: "top-center" });
        }
        else
        {  
            return hqresdata;
        // setValues(hqresdata);
        // let hqcodefinalfilter = hqresdata.map((codedata)=>{return codedata.hqCode});
        // setFiltervalues(hqcodefinalfilter);                      
        }          
    } catch (error) {
      console.log(error);
      return error
    }
}


// export const empsitemapdata = async (empcode) => {
        
//     try {
//         if(!senempmapdata)
//         {
//             toast.error("Please Connect to QRS-Administration.", { position: "top-center" });
//         }
//         else
//         {
//         const res = await fetch('/tcsdb/sitemapdata/'+senempmapdata, {
//             method: "GET",
//                 headers: {
//                 Accept: "application/json",
//                 "Content-Type": "application/json"
//                 },
//                 credentials: "include"  
//         });
//         const empmapdata = await res.json();
//         if(res.status === 404)
//         {
//             toast.error("You have Zero Data Available.", { position: "top-center" });
//         }
//         else
//         {
//         setUsermapData(empmapdata);            
//         setBtnrefstate('none');
//         setBtnreport('');            
//         }
//     }
//     } catch (err) {
//         console.log(err);            
//     }
// }